import BaseServiceCrud from './BaseServiceCrud';

export default class DictionaryService extends BaseServiceCrud {
    constructor() {
        super();
        this.path = 'dictionary';
    }

    getCriteria() {
        return this.objToQueryString({});
    }

    getExpenseCategories() {
        return this.fetch(`${this.domain}/${this.path}/expense-category`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }
    getPayments() {
        return this.fetch(`${this.domain}/${this.path}/payment`, {
            method: 'GET',
        })
            .then((res) => {
                return Promise.resolve(res);
            })
            .catch((err) => {
                throw err;
            });
    }
}
